@use "../../../../../../../../../../styles/Constants.scss" as Constants;
@use "../../../../../../../../../../styles/Colors.scss" as Colors;

.materialCostEntry {
	margin-bottom: 2px;
	padding: Constants.$val-spacing-xs Constants.$val-spacing-s;
	width: 300px;

	&:hover {
		background-color: Colors.$col-greyLight;
	}

	.firstLine {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;

		.sourceNameAndUnit {
			display: flex;
			flex: 1;
			flex-direction: row;
			align-items: center;

			.name {
				font-size: Constants.$val-fontSizeSmall;
				line-height: Constants.$val-lineHeightSmall;
				font-weight: bold;
				margin-left: Constants.$val-spacing-xs;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.unit {
				font-size: Constants.$val-fontSizeSmall;
				line-height: Constants.$val-lineHeightSmall;
				margin-left: Constants.$val-spacing-s;
			}
		}

		.cost {
			flex: 0;
			font-size: Constants.$val-fontSizeSmall;
			line-height: Constants.$val-lineHeightSmall;
			font-weight: bold;
			margin-left: Constants.$val-spacing-xs;
		}
	}

	.description, .vendorLine {
		font-size: Constants.$val-fontSizeXSmall;
		line-height: Constants.$val-lineHeightXSmall;
		color: Colors.$col-design-grey10;
		margin-top: Constants.$val-spacing-s;

		.notAssigned {
			font-style: italic;
		}
	}

	.descriptionVendorOriginalPrice {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.descriptionVendor {
		flex: 1;
	}
	.originalPrice {
		color: Colors.$col-design-grey500;
		font-size: Constants.$val-fontSizeSmall;
		line-height: Constants.$val-lineHeightSmall;
	}
}
